import { Component, OnInit, Input } from '@angular/core';
import { AppService } from '../../services/app.service';

interface richTextConfigInterface {
  content?: string | Array<{value: string, languageCode: string}>;
  class?: string;
  mapping?: {
    contentKey?: string;
  };
}
@Component({
  selector: 'app-rich-text',
  templateUrl: './rich-text.component.html',
  styleUrls: ['./rich-text.component.scss']
})
export class RichTextComponent implements OnInit {

  @Input() config : richTextConfigInterface;
  @Input() data;
  content: string | Array<{value: string, languageCode: string}>;
  class: string = '';
  legend: object = {};

  constructor(private appService : AppService ) { }

  /**
   * @task QLITKAG-2966
   * @author Radhika Agnihotri
   */
  ngOnInit() {
    let path : Array<string>;
    // console.log(this.config);
    if (this.config) {
      if(this.config.hasOwnProperty('class')) {
        this.class = this.config.class;
      }
      // Assign value of config.content to content
      if(this.config.hasOwnProperty('content')) {
        this.content = this.config.content;
      }
  
      // Assign value content according to mapping path
      if(this.config.hasOwnProperty('mapping')){
        //Resolve indexes in mapping -- @NEilC 4/4/2019
        this.config.mapping = this.appService.resolveIndex(this.config.mapping);
        if(this.config.mapping.hasOwnProperty('contentKey')){
          path = this.config.mapping.contentKey.split('.');
          this.content = this.appService.findObjectByPath(this.data, path);
        }
      }
    }
  }
}
